import { VStack } from '@chakra-ui/react';
import { PipelineFilters } from './components/Pipeline/PipelineFilters';
import { PipelineKanban } from './components/Pipeline/PipelineKanban';

export const NotificationsPipelinePage = () => {
  return (
    <VStack alignItems="stretch" height="100%" spacing={4}>
      <PipelineFilters />
      <PipelineKanban />
    </VStack>
  );
};
